export default __webpack_public_path__ + "static/media/auto-kuvat.a87ca132.png";